import * as React from 'react';
import { ChangeVacationCountDialogModel } from './model/TeamModel';
import { TeamController } from './controller/TeamController';
import { Dialog } from 'components/dialog';
import { TextField } from 'components/input/TextField';
import { Button } from '@material-ui/core';

export class ChangeVacationCountDialog extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        var m = props.model;
        this.state = { yearlyVacationCount: m.yearlyVacationCount, rolledVacationCount: m.rolledVacationCount };

        this.handleCancelButtonClicked = this.handleCancelButtonClicked.bind(this);
        this.handleSaveButtonClicked = this.handleSaveButtonClicked.bind(this);
    }

    private handleCancelButtonClicked() {
        this.props.controller.onChangeVacationCountCancelClicked();
    }

    private handleSaveButtonClicked() {
        var m = this.props.model;
        m.yearlyVacationCount = this.state.yearlyVacationCount;
        m.rolledVacationCount = this.state.rolledVacationCount;
        this.props.controller.onChangeVacationCountSaveClicked(m);
    }

    public render() {
        return (
            <Dialog title="Change user vacation count" desc="Edit the form below to change the users current year vacation count!">
                <TextField label="Annual vacation count" value={this.state.yearlyVacationCount} desc="The users current year vacation count." error={this.props.model.yearlyVacationCountError} onChange={(v) => { this.setState({ yearlyVacationCount: v }) }} />
                <TextField label="Rolled vacation count" value={this.state.rolledVacationCount} desc="The rolled vacation count which remains from the previous year." error={this.props.model.rolledVacationCountError} onChange={(v) => { this.setState({ rolledVacationCount: v }) }} />
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                    <Button color="secondary" onClick={this.handleCancelButtonClicked}>Cancel</Button>
                    <Button style={{ marginLeft: '8px' }} color="primary" variant="contained" onClick={this.handleSaveButtonClicked}>Save</Button>
                </div>
            </Dialog>
        );
    }

}

export interface Props {

    model: ChangeVacationCountDialogModel;
    controller: TeamController;

}

interface State {

    yearlyVacationCount: string;
    rolledVacationCount: string;

}
